webpackJsonp([8],{

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Db__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jwt_decode__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(191);





__webpack_require__(713).shim();





__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.request.use(function (config) {
  if (config.skipHeaders) {
    return config;
  }
  config.headers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config.headers || {}, {
    'Accept': 'application/json'
  });
  if (window.localStorage.token) {
    config.headers['Authorization'] = 'Bearer ' + window.localStorage.token;
  }
  return config;
});

__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.response.use(function (response) {
  __WEBPACK_IMPORTED_MODULE_5__Db__["a" /* default */].handleResponse(response);
  return response;
}, function (error) {
  __WEBPACK_IMPORTED_MODULE_5__Db__["a" /* default */].handleError(error);
  console.log('error', error);
  throw error;
});

var Session = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  data: function data() {
    return {
      loading: true,
      jwtExpiration: null,
      showLogin: false,
      user: {
        username: '',
        units: 1,
        firstname: '',
        lastname: '',
        cellnumber: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(window).on('resize', __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(this.resizeFunction, 400));

    setTimeout(function () {
      if (window.localStorage.token) {
        _this.getUser();
      } else {
        _this.loading = false;
      }
    }, 200);

    setInterval(function () {
      if (_this.jwtExpiration && _this.jwtExpiration < Date.now() / 1000) {
        _this.jwtExpiration = null;
        window.localStorage.setItem('token', '');
      }
    }, 10000);
  },

  methods: {
    resizeFunction: function resizeFunction() {
      this.$emit('resize');
    },
    logout: function logout() {
      this.user = {};
      this.jwtExpiration = null;
      window.localStorage.setItem('token', '');
      __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push({ path: '/' });
    },
    getUser: function getUser() {
      var _this2 = this;

      if (window.localStorage.token) {
        var decodedToken = __WEBPACK_IMPORTED_MODULE_6_jwt_decode___default()(window.localStorage.token);
        console.log('dec', decodedToken);
        if (decodedToken && decodedToken.exp) {
          this.jwtExpiration = decodedToken.exp;
        } else {
          console.log('invalid token', decodedToken);
          return;
        }
      }

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_5__Db__["a" /* default */].find('user', '', { force: true, params: { username: 'SELF' } }).then(function (user) {
        _this2.user = user;
        if (__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].currentRoute.path === '/') {
          __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push({ path: '/dashboard' });
          _this2.showLogin = false;
        }
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }
});
window.session = Session;
/* harmony default export */ __webpack_exports__["default"] = (Session);

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Dashboard_Dashboard__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Dashboard_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_Dashboard_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Landing_Landing__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Landing_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_Landing_Landing__);







var QueryString = function QueryString(obj, prefix) {
  var str = [];
  for (var p in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      var k = prefix ? prefix + '[' + p + ']' : p;
      var v = obj[p];
      str.push((typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(v)) === 'object' ? QueryString(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v));
    }
  }
  return str.join('&');
};

__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */].prototype.setQueryParams = function (params) {
  var queryString = {};
  for (var query in this.currentRoute.query) {
    queryString[query] = this.currentRoute.query[query];
  }
  for (var param in params) {
    if (params[param] === null) {
      if (typeof queryString[param] !== 'undefined') {
        delete queryString[param];
      }
    } else {
      queryString[param] = params[param];
    }
  }
  this.push('?' + QueryString(queryString));
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    name: 'Landing',
    component: __WEBPACK_IMPORTED_MODULE_4__modules_Landing_Landing___default.a
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_3__modules_Dashboard_Dashboard___default.a
  }, {
    path: '/data',
    name: 'Data',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(745)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/graphs',
    name: 'Graphs',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/reporting',
    name: 'Reporting',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(749)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/support',
    name: 'Support',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(750)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/users',
    name: 'Users',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(751)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/machines',
    name: 'Machines',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(747)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/profile',
    name: 'Profile',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(748)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { path: '*', redirect: '/' }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scss_style_scss__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scss_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scss_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_outdated_browser_rework_outdated_browser_rework_scss__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_outdated_browser_rework_outdated_browser_rework_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_outdated_browser_rework_outdated_browser_rework_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Session__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__citygro_vue_modal__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__citygro_vue_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__citygro_vue_modal__);





__WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').prepend('<div id="outdated"></div>');

var outdatedBrowserRework = __webpack_require__(711);

outdatedBrowserRework({
  browserSupport: {
    'Chrome': 37,
    'IE': 11,
    'Safari': 10,
    'Mobile Safari': 9,
    'Firefox': 32
  }
});

__webpack_require__(13).polyfill();
__webpack_require__(548).polyfill();
__webpack_require__(299).shim();

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (pattern) {
    var d = this.length - pattern.length;
    return d >= 0 && this.lastIndexOf(pattern) === d;
  };
}







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__citygro_vue_modal___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use({
  install: function install(Vue) {
    var init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      this.$session = __WEBPACK_IMPORTED_MODULE_6__Session__["default"];

      init.call(this, options);
    };

    var destroy = Vue.prototype._destroy;
    Vue.prototype._destroy = function () {
      destroy.apply(this, arguments);
    };
  }
});

new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_toastr__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_toastr__);




__WEBPACK_IMPORTED_MODULE_0_toastr___default.a.options.closeMethod = 'fadeOut';
__WEBPACK_IMPORTED_MODULE_0_toastr___default.a.options.closeDuration = 300;
__WEBPACK_IMPORTED_MODULE_0_toastr___default.a.options.closeEasing = 'swing';
__WEBPACK_IMPORTED_MODULE_0_toastr___default.a.options.newestOnTop = false;
__WEBPACK_IMPORTED_MODULE_0_toastr___default.a.options.timeOut = 4000;
__WEBPACK_IMPORTED_MODULE_0_toastr___default.a.options.extendedTimeOut = 30000;
__WEBPACK_IMPORTED_MODULE_0_toastr___default.a.options.progressBar = true;
__WEBPACK_IMPORTED_MODULE_0_toastr___default.a.options.positionClass = 'toast-bottom-right';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_toastr___default.a);

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_data__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_data_http__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_data_http___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_data_http__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_q__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Toastr__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_property__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__citygro_vdata__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__citygro_vdata___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__citygro_vdata__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_pick__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_pick__);











__WEBPACK_IMPORTED_MODULE_1_js_data__["utils"].Promise = __WEBPACK_IMPORTED_MODULE_3_q___default.a;

var Db = new __WEBPACK_IMPORTED_MODULE_1_js_data__["DataStore"]();

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__citygro_vdata__["vdata"])(Db));

var httpAdapter = new __WEBPACK_IMPORTED_MODULE_2_js_data_http__["HttpAdapter"]({
  basePath: '/rest',
  deserialize: function deserialize(config, response, opts) {
    opts.originalResponse = response;
    var data = response.data;
    console.log('data', response.data);
    if (response.data && !response.id) {
      if (response.data.data && !response.data.id) {
        data = response.data.data;
      } else if (response.data.items && !response.data.id) {
        data = response.data.items;
      } else if (response.data.rows && !response.data.id) {
        data = response.data.rows;
      }
    }
    return data;
  }
});

httpAdapter.http.defaults.transformRequest.push(function (data, headers) {
  if (headers && headers.common) {
    headers.common['Accept'] = 'application/json';
    if (window.localStorage.token) {
      headers.common['Authorization'] = 'Bearer ' + window.localStorage.token;
    }
  }
  return data;
});

Db.handleResponse = function (response) {
  return response;
};

Db.handleError = function (error) {
  if (__WEBPACK_IMPORTED_MODULE_5_lodash_property___default()('status')(error) + '' === '401') {
    var $Session = __webpack_require__(190).default;
    console.log('session', $Session);
    $Session.logout();
    return;
  }
  console.log('handle error', error);
  __WEBPACK_IMPORTED_MODULE_4__components_Toastr__["a" /* default */].error(__WEBPACK_IMPORTED_MODULE_5_lodash_property___default()('response.data')(error) || __WEBPACK_IMPORTED_MODULE_5_lodash_property___default()('data')(error) || error.message, 'Error', {
    preventDuplicates: true
  });
  return error;
};

httpAdapter.http.interceptors.response.use(function (response) {
  return Db.handleResponse(response);
}, function (error, err2) {
  Db.handleError(error);
  throw error;
});

Db.registerAdapter('http', httpAdapter, {
  default: true
});

var modelMap = {
  company: {},
  machine: {
    options: {
      serialize: function serialize(a, b, c) {
        return __WEBPACK_IMPORTED_MODULE_8_lodash_pick___default()(b, ['name', 'location']);
      }
    }
  },
  recordtype: {},
  report: {},
  text: {},
  testtype: {},
  unit: {},
  user: {
    options: {
      idAttribute: 'username',
      serialize: function serialize(a, b, c) {
        return __WEBPACK_IMPORTED_MODULE_8_lodash_pick___default()(b, ['username', 'plainPassword', 'firstname', 'lastname', 'cellnumber', 'company', 'textprovider', 'units', 'admin']);
      }
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(modelMap).forEach(function (modelName) {
  var options = modelMap[modelName].options || {};
  if (!options.idAttribute) {
    options.idAttribute = 'id';
  }
  Db.defineMapper(modelMap[modelName].name || modelName, options);
});

window.Db = Db;

/* harmony default export */ __webpack_exports__["a"] = (Db);

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Breadcrumb__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Login__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_Header___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default.a,
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components_Breadcrumb___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_3__components_Login___default.a
  },
  computed: {}
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
});

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_strap__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a,
    dropdown: __WEBPACK_IMPORTED_MODULE_1_vue_strap__["dropdown"]
  },
  methods: {
    click: function click() {},
    sidebarToggle: function sidebarToggle(e) {
      var _this = this;

      e.preventDefault();
      setTimeout(function () {
        _this.$session.$emit('resize');
      }, 200);
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      var _this2 = this;

      e.preventDefault();
      setTimeout(function () {
        _this2.$session.$emit('resize');
      }, 200);
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      this.$session.$emit('resize');
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      this.$session.$emit('resize');
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var axios = __webpack_require__(180);
var property = __webpack_require__(113);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data() {
    return {
      loading: false,
      error: '',
      email: '',
      password: '',
      forgot: false
    };
  },
  created: function created() {
    this.email = localStorage.email || '';
  },

  methods: {
    forgot: function forgot() {
      window.alert('TODO');
    },
    login: function login() {
      var _this = this;

      if (this.loading) {
        return;
      }
      this.error = '';
      if (!this.email) {
        this.error = 'Please enter an email address.';
        return;
      }
      if (this.forgot) {
        return this.forgot();
      }
      if (!this.password) {
        this.error = 'Please enter a password.';
        return;
      }
      this.loading = true;
      axios({
        method: 'POST',
        url: '/rest/token',
        auth: {
          username: this.email,
          password: this.password
        }
      }).then(function (response) {
        window.localStorage.setItem('token', response.data.token);
        if (response.data.refresh_token) {
          window.localStorage.setItem('refresh_token', response.data.refresh_token);
        }
        window.localStorage.setItem('email', _this.email);
        return _this.$session.getUser();
      }).catch(function (response) {
        if (property('error.data.error')(response)) {
          _this.error = response.error.data.error;
        } else {
          _this.error = 'Unable to log in with those credentials.';
        }
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbar',
  created: function created() {
    this._navbar = true;
  }
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  components: {}
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  components: {}
});

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

module.exports = {
	"br": {
		"outOfDate": "O seu navegador est&aacute; desatualizado!",
		"update": {
			"web": "Atualize o seu navegador para ter uma melhor experi&ecirc;ncia e visualiza&ccedil;&atilde;o deste site. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/br",
		"callToAction": "Atualize o seu navegador agora",
		"close": "Fechar"
	},
	"cn": {
		"outOfDate": "您的浏览器已过时",
		"update": {
			"web": "要正常浏览本网站请升级您的浏览器。",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/cn",
		"callToAction": "现在升级",
		"close": "关闭"
	},
	"cz": {
		"outOfDate": "Váš prohlížeč je zastaralý!",
		"update": {
			"web": "Pro správné zobrazení těchto stránek aktualizujte svůj prohlížeč. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/cz",
		"callToAction": "Aktualizovat nyní svůj prohlížeč",
		"close": "Zavřít"
	},
	"da": {
		"outOfDate": "Din browser er forældet!",
		"update": {
			"web": "Opdatér din browser for at få vist denne hjemmeside korrekt. ",
			"googlePlay": "Installér venligst Chrome fra Google Play",
			"appStore": "Opdatér venligst iOS"
		},
		"url": "http://outdatedbrowser.com/da",
		"callToAction": "Opdatér din browser nu",
		"close": "Luk"
	},
	"de": {
		"outOfDate": "Ihr Browser ist veraltet!",
		"update": {
			"web": "Bitte aktualisieren Sie Ihren Browser, um diese Website korrekt darzustellen. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/de",
		"callToAction": "Den Browser jetzt aktualisieren ",
		"close": "Schließen"
	},
	"ee": {
		"outOfDate": "Sinu veebilehitseja on vananenud!",
		"update": {
			"web": "Palun uuenda oma veebilehitsejat, et näha lehekülge korrektselt. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/ee",
		"callToAction": "Uuenda oma veebilehitsejat kohe",
		"close": "Sulge"
	},
	"en": {
		"outOfDate": "Your browser is out-of-date!",
		"update": {
			"web": "Update your browser to view this website correctly. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "Update my browser now",
		"close": "Close"
	},
	"es": {
		"outOfDate": "¡Tu navegador está anticuado!",
		"update": {
			"web": "Actualiza tu navegador para ver esta página correctamente. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/es",
		"callToAction": "Actualizar mi navegador ahora",
		"close": "Cerrar"
	},
	"fa": {
		"rightToLeft": true,
		"outOfDate": "مرورگر شما منسوخ شده است!",
		"update": {
			"web": "جهت مشاهده صحیح این وبسایت، مرورگرتان را بروز رسانی نمایید. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "همین حالا مرورگرم را بروز کن",
		"close": "Close"
	},
	"fi": {
		"outOfDate": "Selaimesi on vanhentunut!",
		"update": {
			"web": "Lataa ajantasainen selain n&auml;hd&auml;ksesi t&auml;m&auml;n sivun oikein. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "P&auml;ivit&auml; selaimeni nyt ",
		"close": "Sulje"
	},
	"fr": {
		"outOfDate": "Votre navigateur est désuet!",
		"update": {
			"web": "Mettez à jour votre navigateur pour afficher correctement ce site Web. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/fr",
		"callToAction": "Mettre à jour maintenant ",
		"close": "Fermer"
	},
	"hu": {
		"outOfDate": "A böngészője elavult!",
		"update": {
			"web": "Firssítse vagy cserélje le a böngészőjét. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/hu",
		"callToAction": "A böngészőm frissítése ",
		"close": "Close"
	},
	"id": {
		"outOfDate": "Browser yang Anda gunakan sudah ketinggalan zaman!",
		"update": {
			"web": "Perbaharuilah browser Anda agar bisa menjelajahi website ini dengan nyaman. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "Perbaharui browser sekarang ",
		"close": "Close"
	},
	"it": {
		"outOfDate": "Il tuo browser non &egrave; aggiornato!",
		"update": {
			"web": "Aggiornalo per vedere questo sito correttamente. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/it",
		"callToAction": "Aggiorna ora",
		"close": "Chiudi"
	},
	"lt": {
		"outOfDate": "Jūsų naršyklės versija yra pasenusi!",
		"update": {
			"web": "Atnaujinkite savo naršyklę, kad galėtumėte peržiūrėti šią svetainę tinkamai. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "Atnaujinti naršyklę ",
		"close": "Close"
	},
	"nl": {
		"outOfDate": "Je gebruikt een oude browser!",
		"update": {
			"web": "Update je browser om deze website correct te bekijken. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/nl",
		"callToAction": "Update mijn browser nu ",
		"close": "Sluiten"
	},
	"pl": {
		"outOfDate": "Twoja przeglądarka jest przestarzała!",
		"update": {
			"web": "Zaktualizuj swoją przeglądarkę, aby poprawnie wyświetlić tę stronę. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/pl",
		"callToAction": "Zaktualizuj przeglądarkę już teraz",
		"close": "Close"
	},
	"pt": {
		"outOfDate": "O seu browser est&aacute; desatualizado!",
		"update": {
			"web": "Atualize o seu browser para ter uma melhor experi&ecirc;ncia e visualiza&ccedil;&atilde;o deste site. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/pt",
		"callToAction": "Atualize o seu browser agora",
		"close": "Fechar"
	},
	"ro": {
		"outOfDate": "Browserul este învechit!",
		"update": {
			"web": "Actualizați browserul pentru a vizualiza corect acest site. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "Actualizați browserul acum!",
		"close": "Close"
	},
	"ru": {
		"outOfDate": "Ваш браузер устарел!",
		"update": {
			"web": "Обновите ваш браузер для правильного отображения этого сайта. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/ru",
		"callToAction": "Обновить мой браузер ",
		"close": "Закрыть"
	},
	"si": {
		"outOfDate": "Vaš brskalnik je zastarel!",
		"update": {
			"web": "Za pravilen prikaz spletne strani posodobite vaš brskalnik. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/si",
		"callToAction": "Posodobi brskalnik ",
		"close": "Zapri"
	},
	"sv": {
		"outOfDate": "Din webbläsare stödjs ej längre!",
		"update": {
			"web": "Uppdatera din webbläsare för att webbplatsen ska visas korrekt. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "Uppdatera min webbläsare nu",
		"close": "Stäng"
	},
	"ua": {
		"outOfDate": "Ваш браузер застарів!",
		"update": {
			"web": "Оновіть ваш браузер для правильного відображення цього сайта. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/ua",
		"callToAction": "Оновити мій браузер ",
		"close": "Закрити"
	}
};

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(733),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(729),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(557)

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(735),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(730),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 724:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(728),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(732),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(731),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(556)

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(734),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 728:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "breadcrumb-item"
    }, [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
},staticRenderFns: []}

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center login-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('form', {
    staticClass: "card-block",
    staticStyle: {
      "position": "relative"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [(_vm.$session.showLogin) ? _c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "color": "#000",
      "position": "absolute",
      "top": "0px",
      "right": "0px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.$session.showLogin = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("Log In")]), _vm._v(" "), (_vm.forgot) ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Reset your password")]) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Sign In to your account")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.forgot) ? _c('div', {
    staticClass: "input-group mb-4"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "role": "button",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.forgot ? 'Continue' : 'Log In') + " "), (_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [(_vm.forgot) ? _c('button', {
    staticClass: "btn btn-link px-0",
    attrs: {
      "role": "button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.forgot = false
      }
    }
  }, [_vm._v("Nevermind")]) : _c('button', {
    staticClass: "btn btn-link px-0",
    attrs: {
      "role": "button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.forgot = true
      }
    }
  }, [_vm._v("Forgot password?")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "width": "43px"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "width": "43px"
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])
}]}

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn container-fluid top-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('br'), _vm._v(" "), _c('h2', [_vm._v("Welcome to the Highlight Film Test Stand Portal")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("This portal allows you to review the data, create graphs and analyze results of film tests from across multiple testing systems.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-wrapper text-right"
  }, [_c('div', [_vm._v("\n            Data allows you to select the date range to view your test results.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 img-wrapper"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "static/img/dashboard1.jpg",
      "width": "100%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, [_c('div', {
    staticClass: "col-sm-8 img-wrapper"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "static/img/dashboard3.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-wrapper"
  }, [_c('div', [_vm._v("\n            Graphs allow you to create graphs within a specific data and time range encompassing the range of film tests\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-wrapper text-right"
  }, [_c('div', [_vm._v("\n            You can also view graphs for multiple tests of the same type in a single graph.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 img-wrapper"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "static/img/dashboard3.jpg",
      "width": "100%"
    }
  })])])])])])])
}]}

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/dashboard'
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Overview ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n        Pages\n      ")]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/data'
    }
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _vm._v(" Data\n        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/graphs'
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Graphs\n        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/support',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-support"
  }), _vm._v(" Support\n        ")])], 1)]), _vm._v(" "), (_vm.$session.user.company) ? _c('div', {
    staticClass: "company-logo"
  }, [(_vm.$session.user.company.logo) ? _c('img', {
    attrs: {
      "src": _vm.$session.user.company.logo
    }
  }) : _c('span', [_vm._v("\n        " + _vm._s(_vm.$session.user.company.name) + "\n      ")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer-wrapper"
  }, [(!_vm.$session.loading && !(_vm.$session.user && _vm.$session.user.username) && this.$route.name === 'Landing') ? _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": 300,
      "name": "appfade"
    }
  }, [(_vm.$session.loading) ? _c('div', {
    staticClass: "main-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": 1000,
      "name": "applogin"
    }
  }, [(!(_vm.$session.user && _vm.$session.user.username && _vm.$session.jwtExpiration) && (this.$route.name !== 'Landing' || (this.$route.name === 'Landing' && _vm.$session.showLogin))) ? _c('login') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": 1000,
      "name": "appfade"
    }
  }, [(_vm.$session.user && _vm.$session.user.username) ? _c('div', {
    staticClass: "app"
  }, [_c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "app-footer"
  }, [_vm._v("\n        Test Stand Portal © 2017 Highlight Industries.\n      ")])], 1) : _vm._e()]), _vm._v(" "), _c('modal-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 734:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-wrapper"
  }, [_c('nav', {
    staticClass: "navbar navbar-custom navbar-fixed-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "login-link",
    on: {
      "click": function($event) {
        _vm.$session.showLogin = true
      }
    }
  }, [_vm._v("Log In")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 offset-2"
  }, [_c('h1', {
    staticClass: "brand-heading"
  }, [_vm._v("Test Stand Portal")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-circle page-scroll",
    attrs: {
      "href": "#about"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down animated"
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container content-section text-center",
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 offset-2"
  }, [_c('h2', [_vm._v("Powered by HIGHLIGHT Industries")]), _vm._v(" "), _c('p', [_vm._v("Highlight was founded in 1981 with a mission to provide the highest value highest quality and highest technology products to our customers. Highlight is the world leader in equipment for testing stretch film. In addition Highlight provides the technology and equipment to evaluate the overall equipment and film effectiveness to increase production, reduce costs and ensure that products arrives undamaged. The HiLIFE System continues our commitment to provide the highest quality, highest value, highest technology solutions to the industry.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticStyle: {
      "background-color": "rgba(100, 100, 100, 1)",
      "color": "#fff",
      "margin-top": "50px"
    }
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('p', [_vm._v("Copyright © 2017 Highlight Industries")])])])
}]}

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "hidden-md-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")])]), _vm._v(" "), (_vm.$session.user && _vm.$session.user.admin) ? _c('li', {
    staticClass: "nav-item px-3"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/users',
      "exact": ""
    }
  }, [_vm._v("Users")])], 1) : _vm._e(), _vm._v(" "), (_vm.$session.user && _vm.$session.user.admin) ? _c('li', {
    staticClass: "nav-item px-3"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/machines',
      "exact": ""
    }
  }, [_vm._v("Machines")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto"
  }, [_c('dropdown', {
    staticClass: "nav-item",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    slot: "button"
  }, [_c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.$session.user.firstname) + " " + _vm._s(_vm.$session.user.lastname))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    slot: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v("Account")])]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": '/profile',
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Profile")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.$session.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-item d-md-down-none"
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 741:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(285);
module.exports = __webpack_require__(284);


/***/ })

},[742]);


// WEBPACK FOOTER //
// static/js/app.js